<template>
  <div class="app-home">
    <div class="aside">
      <!--侧边显示:代办处开始-->
      <div class="top"></div>
      <div class="title" v-show="this.isAgent">
        <img :src="require('@/assets/images/member/dot01.jpg')" alt="">
        <!--个人资料-->
        <span>{{ $t('me.userzl') }}</span>
      </div>
      <div class="wel" v-show="this.isAgent">
        <!--欢迎您-->
        <div class="wel-txt">{{ $t('msg.welcome.prefix') }}</div>
        <div class="code">{{ userCode }}</div>
      </div>
      <div class="menu" v-show="this.isAgent">
        <div class="item">
          <img class="icon" :src="require('@/assets/images/member/icon_user.png')" alt="">
          <div class="title">
            <div>{{ username }}</div>
          </div>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/member/icon_note.png')" alt="">
          <div class="title">
            <!--电子账户-->
            <div v-show="!loading">{{ $t('fi.type.ac.e') }}: <span class="tip">{{ Number(home.F$).toFixed(2) }}</span>
            </div>
          </div>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/member/icon_edit.png')" alt="">
          <div class="title">
            <div>{{ $t('me.agologin') }}</div>
            <div class="tip">{{ home.lastLoginTime }}</div>
          </div>
        </div>
      </div>
      <!--      <div v-show="this.isAgent">-->
      <!--        <div>Android App</div>-->
      <!--        <img v-show="appDownShow" class="icon" :src="require('@/assets/images/chitu_qrcode.png')"-->
      <!--             style="width: 200px;height: auto;vertical-align: top" alt="">-->
      <!--        &lt;!&ndash;点击下载 TODO:上线修要修改app下载地址&ndash;&gt;-->
      <!--        &lt;!&ndash;        <div><a href="http://13.245.128.42/html/app.apk">{{ $t('ic.download') }}</a></div>&ndash;&gt;-->
      <!--        <div><p @click="downApp"-->
      <!--                style="margin: 0;text-align: center;text-decoration: underline;color: #0a57a4;cursor: pointer">-->
      <!--          {{ $t('ic.download') }}</p></div>-->
      <!--      </div>-->
      <!--侧边显示:代办处结束-->
      <!--侧边显示:经销商开始-->
      <div class="menu" v-show="!this.isAgent">
        <div style="background-color: #FFF;padding: 0 10px">
          <el-image :src="DistributorCardSrc" :preview-src-list="DistributorCardSrcList" style="margin-top: 20px">
            <div slot="error" class="image-slot">
              loading<span class="dot">...</span>
            </div>
          </el-image>
          <p style="display:inline-block;transform: scale(0.8);margin: 0 0 10px 0;cursor: pointer" @click="downMemberCard">Download Distributor Card</p>
          <div style="background-color: #ECECEC;border-bottom: 1px solid #EBEEF5">
            <!--公告-->
            <p style="display: inline-block;float: left;font-weight: bold">{{ $t('icAnnounceList.list') }}</p>
            <!--更多-->
            <el-button style="display: inline-block;float: right;" type="text" @click="moreClick">
              {{ $t('operation.notice.more') }}
            </el-button>
          </div>
          <el-table :key="tableKey" :data="memberList" :border="false" :show-header="false">
            <el-table-column>
              <template v-slot="{row}">
                <h4 class="announceTitle" @click="newsClick(row.announceId)">{{ row.title }} - ( {{ row.createTime }} )</h4>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/member/icon_edit.png')" alt="">
          <div class="title">
            <div>{{ $t('me.agologin') }}</div>
            <div class="tip">{{ home.lastLoginTime }}</div>
          </div>
        </div>
        <div class="item">
          <div class="title">{{this.$t('miMember.cardType')}}:</div>
          <div style="color: green;font-weight: 600">{{$lt(initDict.levelType,listQuery.levelType)}}</div>
        </div>
        <div class="item">
          <div class="title">{{this.$t('mi.honourLevel')}}:</div>
          <div style="color: green;font-weight: 600">{{$lt(initDict.cardType,listQuery.cardType)}}</div>
        </div>
      </div>
      <!--侧边显示:经销商结束-->
    </div>
    <div class="content-wrapper">
      <div class="top"></div>
      <div class="notice">
        <!--主要内容:代办处开始-->
        <el-card class="box-card" v-show="this.isAgent">
          <div slot="header" class="clearfix">
            <!--新闻公告-->
            <span>{{ $t('ic.news.announce') }}</span>
            <!--更多-->
            <el-button style="float: right; padding: 3px 0" type="text" @click="moreClick">
              {{ $t('operation.notice.more') }}
            </el-button>
          </div>
          <el-table :key="tableKey" :data="agentList" :border="false" :show-header="false">
            <el-table-column>
              <template v-slot="{ row }">
                <h4 class="announceTitle" @click="newsClick(row.announceId)">{{ row.title }} - ( {{ row.createTime }} )</h4>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <!--主要内容:代办处结束-->
        <!--主要内容:经销商开始-->
        <el-card v-loading="loading" class="box-card" style="margin-bottom: 5px" v-show="!this.isAgent">
          <div class="main_container" style="padding: 10px 0">
            <div style="text-align: right;">
              <p style="transform: scale(0.8);margin: 0;display: inline-block">Data update time: {{ preTime }}(GMT)</p>
            </div>
            <div class="main_container_top" style="display: flex;justify-content: space-around;margin-bottom: 10px">
              <div style="width: 212px;height: 110px;">
                <p style="display: block;margin: 10px 0 3px 0;text-align: left;font-size: 16px;line-height: 16px;color: #f09b3a;">
                  <!--本周业绩截止日期-->
                  {{ $t('Closing.date.week.results') }}
                </p>
                <p style="display:block;margin: 0 0 3px 0;height: 14px;font-size: 14px;line-height: 14px;color: #858587;">
                  <span>{{ timeThisWeek.LAST_DAY }}</span>
                </p>
                <p style="display:block;margin: 0 0 3px 0;transform: scale(0.8);height: 12px;font-size: 12px;line-height: 12px;">
                  <span>Days</span>
                  <span style="margin-left:23px ">Hours</span>
                  <span style="margin-left:21px ">Minutes</span>
                  <span style="margin-left:17px ">Seconds</span></p>
                <p style="display: inline-block;margin: 0 0 0 -8px;height: 28px;font-size: 28px;line-height: 28px;font-weight: 600;color: #221816;">
                  <span v-if="this.Remaining_milliseconds>0">
                    {{
                      timeThisWeek.ENDDAY + ':' + timeThisWeek.ENDHOUR + ':' + timeThisWeek.ENDMINUTE + ':' + timeThisWeek.ENDSECOND
                    }}
                  </span>
                  <span v-else style="color: #858587">{{ $t('timeout') }}</span>
                </p>
              </div>
              <div style="width: 0;height: 110px;border: 1px solid #EBEEF5;"></div>
              <div style="width: 212px;height: 110px;">
                <!--本月业绩截止日期:-->
                <p style="font-size: 16px;line-height: 16px;color: #f09b3a;">
                  {{ $t('Closing.date.month.performance') }}
                </p>
                <p style="text-align: center;transform: scale(0.95);font-size: 15px;line-height: 15px;color: #333;">
                  <span v-if="timeMonthWeek.DAYNUM>0">{{ timeMonthWeek.END_DATE }}</span>
                  <span v-else>{{ $t('timeout') }}</span>
                </p>
                <p v-if="timeMonthWeek.DAYNUM>0"
                   style=" height: 15px; font-size: 15px; line-height: 15px; color: #333;">
                  {{ $t('Countdown') }}: {{ timeMonthWeek.DAYNUM }} {{ $t('labe.day') }}
                </p>
              </div>
<!--              <div style="width: 212px;height: 110px;border-left: 1px solid #EBEEF5;">
                &lt;!&ndash;升级截止日期:&ndash;&gt;
                <p style="white-space: nowrap;height: 16px;font-size: 16px;line-height: 16px;color: #f09b3a;">
                  {{ $t('Upgrade.deadline') }}</p>
                <p style="white-space: nowrap;transform: scale(0.95);font-size: 15px;line-height: 15px;color: #333;">
                  <span v-if="upgradeDays.UPDAY>0">{{ upgradeDays.UPDAYTIME }}</span>
                  <span v-else style="color: red">{{ $t('timeout') }}</span>
                </p>
                <p style="font-size: 15px;line-height: 15px;color: #333;">
                  {{ $t('Countdown') }}: {{ upgradeDays.UPDAY }} {{ $t('labe.day') }}
                </p>
              </div>-->
            </div>
            <div style="background-color: #f2f2f2;overflow:hidden;">
              <ul class="muchLi" style="margin: 0 1px;list-style: none;padding: 0;">
                <li v-for="(val,idx) in memberMainList" :key="idx" class="eachDiv"
                    style="width: 106px;float: left;background-color: #f2f2f2">
                  <div class="svgDiv" style="padding: 10px 0 0 0">
                    <img :src="val.img" alt="图标"
                         style="width: 40px;height: 40px">
                  </div>
                  <div>
                    <p style="display: block;margin: 3px auto;width: 90px">
                      <span v-if="val.title.indexOf('+')>-1">
                        {{ $t(val.title.split('+')[0]) + $t(val.title.split('+')[1]) }}</span>
                      <span v-else>{{ $t(val.title) }}</span>
                    </p>
                    <p style="display: block;margin: 3px auto;width: 90px">
                      <span v-if="val.units_nums===0">
                        {{ val.value_list[0] }}
                      </span>
                      <span v-else-if="val.units_nums===1">
                        {{ val.value_list[0] }}{{ val.units_list[0] }}
                      </span>
                      <span v-else>
                        {{ val.value_list[0] }}{{ val.units_list[0] }}
                        {{ val.value_list[1] }}{{ val.units_list[1] }}
                      </span>
                    </p>
                  </div>
                </li>
                <li v-for="(val,idx) in memberMainList2" :key="idx+memberMainList.length" class="eachDiv"
                    style="width: 106px;float: left;background-color: #f2f2f2">
                  <div class="svgDiv" style="padding: 10px 0 0 0">
                    <svg v-if="val.isCheck" style="width: 40px;height: 40px;" t="1610933382035" class="icon"
                         viewBox="0 0 1024 1024"
                         version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9452" width="200" height="200">
                      <path
                          d="M512 0C229.272524 0 0 229.272524 0 512s229.272524 512 512 512 512-229.272524 512-512S794.727476 0 512 0zM848.182428 322.366555L417.177554 753.359982a36.628661 36.628661 0 0 1-51.71509 0L175.817572 563.715091a36.628661 36.628661 0 0 1 51.726537-51.715091l163.7759 163.7759 405.135882-405.135882a36.628661 36.628661 0 0 1 51.71509 51.71509z"
                          p-id="9453" fill="#2aa515"></path>
                    </svg>
                    <svg v-else style="width: 40px;height: 40px;" t="1610933502363" class="icon" viewBox="0 0 1024 1024"
                         version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11152" width="200" height="200">
                      <path
                          d="M512 0.011C229.23 0.011 0.011 229.23 0.011 512S229.23 1023.989 512 1023.989 1023.989 794.77 1023.989 512 794.77 0.011 512 0.011z m217.23 343.033L560.272 512 729.23 680.956a34.136 34.136 0 0 1-48.273 48.273L512 560.273 343.044 729.23a34.136 34.136 0 0 1-48.273-48.273L463.727 512 294.77 343.044a34.136 34.136 0 0 1 48.273-48.273L512 463.727 680.956 294.77a34.136 34.136 0 0 1 48.273 48.273z"
                          p-id="11153" fill="#d81e06"></path>
                    </svg>
                  </div>
                  <div>
                    <p style="display: block;margin: 3px auto;width: 90px">{{ $t('Home.Week') +':'}}{{ val.value }}</p>
                  </div>
                </li>
              </ul>
            </div>
            <div style="width: 100%;">
              <div class="cont_btm_top">
                <p style="display: inline-block;height: 42px;line-height: 42px;float: left;margin: 0">
                  &nbsp;&nbsp;&nbsp;&nbsp;Team Bonus
                </p>
                <p style="display: inline-block;height: 42px;line-height: 42px;float: right;margin: 0">
                  {{ sustainableDevelopment.BONUS_SERVICE }} USD &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </p>
              </div>
              <div class="cont_btm_mid" @click="showMapFn">
                <p style="display: inline-block;height: 42px;line-height: 42px;float: left;margin: 0">
                  &nbsp;&nbsp;&nbsp;&nbsp;Development Bonus
                </p>
                <p style="display: inline-block;height: 42px;line-height: 42px;float: right;margin: 0">
                  {{ sustainableDevelopment.BONUS_MARKET }} USD &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </p>
                <div :class="showMap ? 'triangular2' : 'triangular'"></div>
              </div>
              <div v-show="showMap" class="cont_btm_btm">
                <!--总计1个点位-->
                <div v-if="bonusNum===1">
                  <div
                      style="width: 200px;background-color: #fceab4;margin: 10px auto;border: 1px solid #F09633;overflow: hidden">
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                      {{ bonus1.RIGHT_NO }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ $lt(initDict.cnmemberlevel, bonus1.NEW_LEVEL_TYPE) }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NAME }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                      {{ bonus1.NET_AMOUNT }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NET_SELL }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                      {{ bonus1.LEIJIFQ }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus1.LEIJIFV }}</p>
                  </div>
                </div>
                <!--总计2个点位-->
                <div v-if="bonusNum===2">
                  <div
                      style="width: 200px;background-color: #fceab4;margin: 10px auto 0;border: 1px solid #F09633;overflow: hidden">
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                      {{ bonus1.RIGHT_NO }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ $lt(initDict.cnmemberlevel, bonus1.NEW_LEVEL_TYPE) }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NAME }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                      {{ bonus1.NET_AMOUNT }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NET_SELL }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                      {{ bonus1.LEIJIFQ }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus1.LEIJIFV }}</p>
                  </div>
                  <div style="width: 0;height: 20px;border: 1px solid black;position: relative;left: 49.9%"/>
                  <div
                      style="width: 200px;background-color: #fceab4;margin: 0 auto 10px;border: 1px solid #F09633;overflow: hidden">
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                      {{ bonus2.RIGHT_NO }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ $lt(initDict.cnmemberlevel, bonus2.NEW_LEVEL_TYPE) }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus2.NAME }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                      {{ bonus2.NET_AMOUNT }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus2.NET_SELL }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                      {{ bonus2.LEIJIFQ }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus2.LEIJIFV }}</p>
                  </div>
                </div>
                <!--总计3个点位-->
                <div v-if="bonusNum===3">
                  <div
                      style="width: 200px;background-color: #fceab4;margin: 10px auto 0;border: 1px solid #F09633;overflow: hidden">
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                      {{ bonus1.RIGHT_NO }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ $lt(initDict.cnmemberlevel, bonus1.NEW_LEVEL_TYPE) }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NAME }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                      {{ bonus1.NET_AMOUNT }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NET_SELL }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                      {{ bonus1.LEIJIFQ }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus1.LEIJIFV }}</p>
                  </div>
                  <div style="width: 100%">
                    <div style="width: 0;height: 10px;border: 1px solid black;position: relative;left: 49.9%"/>
                    <div
                        style="width: 330px;height: 10px;border-top: 2px solid black;border-left: 2px solid black;border-right: 2px solid black;position: relative;left: 150px"/>
                  </div>
                  <div style="width: 100%;overflow: hidden">
                    <div
                        style="float: left;margin: 0 0 10px 50px;width: 200px;background-color: #fceab4;border: 1px solid #F09633;overflow: hidden">
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                        {{ bonus2.RIGHT_NO }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ $lt(initDict.cnmemberlevel, bonus2.NEW_LEVEL_TYPE) }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus2.NAME }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                        {{ bonus2.NET_AMOUNT }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus2.NET_SELL }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                        {{ bonus2.LEIJIFQ }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus2.LEIJIFV }}</p>
                    </div>
                    <div
                        style="float: right;margin: 0 50px 10px 0;width: 200px;background-color: #fceab4;border: 1px solid #F09633;overflow: hidden">
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                        {{ bonus3.RIGHT_NO }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ $lt(initDict.cnmemberlevel, bonus3.NEW_LEVEL_TYPE) }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus3.NAME }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                        {{ bonus3.NET_AMOUNT }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus3.NET_SELL }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                        {{ bonus3.LEIJIFQ }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus3.LEIJIFV }}</p>
                    </div>
                  </div>
                </div>
                <!--总计4个点位-->
                <div v-if="bonusNum===4">
                  <div
                      style="width: 200px;background-color: #fceab4;margin: 10px auto 0;border: 1px solid #F09633;overflow: hidden">
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                      {{ bonus1.RIGHT_NO }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ $lt(initDict.cnmemberlevel, bonus1.NEW_LEVEL_TYPE) }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NAME }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                      {{ bonus1.NET_AMOUNT }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NET_SELL }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                      {{ bonus1.LEIJIFQ }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus1.LEIJIFV }}</p>
                  </div>
                  <div style="width: 100%">
                    <div style="width: 0;height: 20px;border: 1px solid black;position: absolute;right: 350px"/>
                    <div
                        style="width: 330px;height: 10px;border-top: 2px solid black;border-left: 2px solid black;border-right: 2px solid black;position: relative;left: 150px;top:10px"/>
                  </div>
                  <div style="width: 100%;overflow: hidden">
                    <div
                        style="float: left;margin: 10px 0 10px 10px;width: 200px;background-color: #fceab4;border: 1px solid #F09633;overflow: hidden">
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                        {{ bonus2.RIGHT_NO }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ $lt(initDict.cnmemberlevel, bonus2.NEW_LEVEL_TYPE) }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus2.NAME }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                        {{ bonus2.NET_AMOUNT }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus2.NET_SELL }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                        {{ bonus2.LEIJIFQ }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus2.LEIJIFV }}</p>
                    </div>
                    <div
                        style="float: left;margin: 10px 0 10px 10px;width: 200px;background-color: #fceab4;border: 1px solid #F09633;overflow: hidden">
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                        {{ bonus3.RIGHT_NO }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ $lt(initDict.cnmemberlevel, bonus3.NEW_LEVEL_TYPE) }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus3.NAME }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                        {{ bonus3.NET_AMOUNT }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus3.NET_SELL }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                        {{ bonus3.LEIJIFQ }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus3.LEIJIFV }}</p>
                    </div>
                    <div
                        style="float: left;margin: 10px 0 10px 10px;width: 200px;background-color: #fceab4;border: 1px solid #F09633;overflow: hidden">
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                        {{ bonus4.RIGHT_NO }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ $lt(initDict.cnmemberlevel, bonus4.NEW_LEVEL_TYPE) }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus4.NAME }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                        {{ bonus4.NET_AMOUNT }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus4.NET_SELL }}</p>
                      <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                        {{ bonus4.LEIJIFQ }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus4.LEIJIFV }}</p>
                    </div>
                  </div>
                </div>
                <!--总计5个点位-->
                <div v-if="bonusNum===5">
                  <div
                      style="width: 200px;background-color: #fceab4;margin: 10px auto 0;border: 1px solid #F09633;overflow: hidden">
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                      {{ bonus1.RIGHT_NO }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ $lt(initDict.cnmemberlevel, bonus1.NEW_LEVEL_TYPE) }}</p>
                    <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NAME }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                      {{ bonus1.NET_AMOUNT }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                      {{ bonus1.NET_SELL }}</p>
                    <p style="display:block;width: 99px;margin: 0;float: left;border-right: 1px solid #F09633;">
                      {{ bonus1.LEIJIFQ }}</p>
                    <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus1.LEIJIFV }}</p>
                  </div>
                  <div style="width: 100%">
                    <div style="width: 0;height: 10px;border: 1px solid black;position: absolute;right: 350px"/>
                    <div style="width: 570px;height: 10px;border-top: 2px solid black;border-left: 2px solid black;border-right: 2px solid black;position: relative;left:30px;top:10px"/>
                    <div style="width: 0;height:8px;border: 1px solid black;position: absolute;left:530px"/>
                    <div style="width: 0;height:8px;border: 1px solid black;position: absolute;left: 700px"/>
                  </div>
                  <div style="width: 100%;overflow: hidden">
                    <div
                        style="float: left;margin: 10px 0 10px 0px;width: 140px;background-color: #fceab4;border: 1px solid #F09633;overflow: hidden">
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                        {{ bonus2.RIGHT_NO }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ $lt(initDict.cnmemberlevel, bonus2.NEW_LEVEL_TYPE) }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus2.NAME }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                        {{ bonus2.NET_AMOUNT }}</p>
                      <p style="display:block;width: 49%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus2.NET_SELL }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-right: 1px solid #F09633;">
                        {{ bonus2.LEIJIFQ }}</p>
                      <p style="display:block;width: 49%;margin: 0;float: left">{{ bonus2.LEIJIFV }}</p>
                    </div>
                    <div
                        style="float: right;margin: 10px 0px 10px 0;width: 140px;background-color: #fceab4;border: 1px solid #F09633;overflow: hidden">
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                        {{ bonus3.RIGHT_NO }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ $lt(initDict.cnmemberlevel, bonus3.NEW_LEVEL_TYPE) }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus3.NAME }}</p>
                      <p style="display:block;width: 49%;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                        {{ bonus3.NET_AMOUNT }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus3.NET_SELL }}</p>
                      <p style="display:block;width: 49%;margin: 0;float: left;border-right: 1px solid #F09633;">
                        {{ bonus3.LEIJIFQ }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus3.LEIJIFV }}</p>
                    </div>
                    <div
                        style="float: left;margin:10px 0px;width: 140px;background-color: #fceab4;border: 1px solid #F09633;overflow: hidden;position: relative;left: 20px ">
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                        {{ bonus4.RIGHT_NO }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ $lt(initDict.cnmemberlevel, bonus4.NEW_LEVEL_TYPE) }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus4.NAME }}</p>
                      <p style="display:block;width: 49%;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                        {{ bonus4.NET_AMOUNT }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus4.NET_SELL }}</p>
                      <p style="display:block;width: 49%;margin: 0;float: left;border-right: 1px solid #F09633;">
                        {{ bonus4.LEIJIFQ }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus4.LEIJIFV }}</p>
                    </div>
                    <div
                        style="float: right;margin: 10px 0 0 0;width: 140px;background-color: #fceab4;border: 1px solid #F09633;overflow: hidden;position: relative;right: 20px;">
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;color: #ddb97e;">
                        {{ bonus5.RIGHT_NO }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ $lt(initDict.cnmemberlevel, bonus5.NEW_LEVEL_TYPE) }}</p>
                      <p style="display:block;width: 100%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus5.NAME }}</p>
                      <p style="display:block;width: 49%;margin: 0;float: left;border-bottom: 1px solid #F09633;border-right: 1px solid #F09633;">
                        {{ bonus5.NET_AMOUNT }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left;border-bottom: 1px solid #F09633;">
                        {{ bonus5.NET_SELL }}</p>
                      <p style="display:block;width: 49%;margin: 0;float: left;border-right: 1px solid #F09633;">
                        {{ bonus5.LEIJIFQ }}</p>
                      <p style="display:block;width: 50%;margin: 0;float: left">{{ bonus5.LEIJIFV }}</p>
                    </div>
                  </div>
                </div>
                <p style="position: absolute;bottom: 5px;right: 30px;font-size: 15px;line-height: 15px">
                  {{ sustainableDevelopment.BONUS_MARKET }} USD
                </p>
              </div>
            </div>
          </div>
        </el-card>
        <!--主要内容:经销商结束-->
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {num2string} from '@/utils/num2string'
import {accountBalanceSum, fetchHomepage, getAllMessage} from '@/api/home'
import {memberCard} from "@/api/ay-personal-center/personalcenter";
// import {fetchHomepage, fetchNumbers, downAppLocal} from '@/api/home'
import { icAnnouncesList1 } from '@/api/ic/IcAnnounce'

export default {
  name: 'Home',
  data() {
    return {
      listQuery:{},
      agentList: [],
      memberList: [],
      tableData: [],
      activeNames: '',
      preTime: '',
      Remaining_milliseconds: 0,
      sustainableDevelopment: {
        BONUS_MARKET: 0,
        BONUS_SERVICE: 0
      },
      timeThisWeek: {
        ENDDAY: 0,
        ENDHOUR: 0,
        ENDMINUTE: 0,
        ENDSECOND: 0,
        LAST_DAY: ''
      },
      timeMonthWeek: {
        DAYNUM: 0,
        END_DATE: ''
      },
      upgradeDays: {
        UPDAY: '',
        UPDAYTIME: ''
      },
      memberMainList: [
        {
          img: require('@/assets/images/tubiao1_334_335.png'),
          title: 'IDU.Purchase.Performance', // 当期个人购买业绩
          units_nums: 2,
          units_list: ['USD', 'FV'],
          value_list: ['', '']
        },
        {
          img: require('@/assets/images/tubiao2_334_335.png'),
          title: 'yournewrecommendation', // 您新推荐人数
          units_nums: 0,
          units_list: [],
          value_list: ['']
        },
        {
          img: require('@/assets/images/tubiao3_334_334.png'),
          title: 'Number.New.Referrals', // 您网络中新推荐人数
          units_nums: 0,
          units_list: [],
          value_list: ['']
        },
        {
          img: require('@/assets/images/tubiao4_335_335.png'),
          title: 'point.lastPoint', // 保留业绩
          units_nums: 1,
          units_list: ['FV'],
          value_list: ['']
        },
        {
          img: require('@/assets/images/tubiao5_334_335.png'),
          title: 'MDA.CV', // 市场开拓奖累计值
          units_nums: 1,
          units_list: ['USD'],
          value_list: ['']
        },
        {
          img: require('@/assets/images/tubiao6_334_335.png'),
          title: 'E.WALLET',
          units_nums: 1,
          units_list: ['USD'],
          value_list: ['']
        },
        {
          img: require('@/assets/images/tubiao7_334_335.png'),
          title: 'E.Dollar',
          units_nums: 0,
          units_list: [],
          value_list: ['']
        },
        {
          img: require('@/assets/images/tubiao8_335_335.png'),
          title: 'fi.type.ac.consume', // 重消账户
          units_nums: 1,
          units_list: ['USD'],
          value_list: ['']
        }
      ],
      memberMainList2: [
        {
          isCheck: true,
          value: ''
        },
        {
          isCheck: true,
          value: ''
        },
        {
          isCheck: true,
          value: ''
        },
        {
          isCheck: true,
          value: ''
        }
      ],
      showMap: false,
      loading: false,
      appDownShow: false,
      MemberData: {},
      bonusNum: 0,
      bonus1: {
        RIGHT_NO: '1-111',
        NEW_LEVEL_TYPE: '1-222',
        NAME: '1-333',
        NET_AMOUNT: '1-444',
        NET_SELL: '1-555',
        LEIJIFQ: '1-666',
        LEIJIFV: '1-777'
      },
      bonus2: {
        RIGHT_NO: '2-111',
        NEW_LEVEL_TYPE: '2-222',
        NAME: '2-333',
        NET_AMOUNT: '2-444',
        NET_SELL: '2-555',
        LEIJIFQ: '2-666',
        LEIJIFV: '2-777'
      },
      bonus3: {
        RIGHT_NO: '3-111',
        NEW_LEVEL_TYPE: '3-222',
        NAME: '3-333',
        NET_AMOUNT: '3-444',
        NET_SELL: '3-555',
        LEIJIFQ: '3-666',
        LEIJIFV: '3-777'
      },
      bonus4: {
        RIGHT_NO: '4-111',
        NEW_LEVEL_TYPE: '4-222',
        NAME: '4-333',
        NET_AMOUNT: '4-444',
        NET_SELL: '4-555',
        LEIJIFQ: '4-666',
        LEIJIFV: '4-777'
      },
      bonus5: {
        RIGHT_NO: '5-111',
        NEW_LEVEL_TYPE: '5-222',
        NAME: '5-333',
        NET_AMOUNT: '5-444',
        NET_SELL: '5-555',
        LEIJIFQ: '5-666',
        LEIJIFV: '5-777'
      },
      home: {
        F$: '',
        PV: '',
        F0: '',
        lastLoginTime: ''
      },
      tableKey: 1,
      notices: [],
      DistributorCardSrcList: [''],
      DistributorCardSrc: '',
      initDict: {
        cnmemberlevel: 'mimember.cardtype',
        levelType:'cn.member.level',
        cardType:'cn.mimember.cardtype'
      }

    }
  },
  computed: {
    ...mapGetters([
      'language',
      'companyCode',
      'userCode',
      'username',
      'isAgent'
    ]),
    mimembercardtype() {
      return this.$ll(this.initDict.mimembercardtype)
    },
  },
  created() {
    this.getList()
  },
  mounted() {
    this.getData()
  },
  methods: {
    getList() {
      icAnnouncesList1().then(res => {
        this.memberList = res.data.records.length === 0 ? [] : [res.data.records[0]]
        this.agentList = res.data.records.length === 0 ? [] : res.data.records.slice(0,3)
      })
    },
    downMemberCard() {
      if (this.DistributorCardSrc.length>10) {
        this.base64ToAnyfile(this.DistributorCardSrc,'MemberCard','png')
      }
    },
    base64ToAnyfile(longStr, fileName, exName) {
      if (!fileName) {
        fileName = 'unNamed'
      }
      if (!exName) {
        exName = 'unknowType'
      }
      const dataArr = longStr.split(',')
      const base64Data = dataArr[1] // 文件数据
      const contentType = dataArr[0] // 文件类型头
      const bytes64 = atob(base64Data)
      const byteData = new ArrayBuffer(bytes64.length)
      const array = new Uint8Array(byteData)
      for (let i = 0; i < bytes64.length; i++) {
        array[i] = bytes64.charCodeAt(i)
      }
      const _blob = new Blob([byteData], {
        type: contentType
      })
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(_blob, fileName + '.' + exName)
      } else {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(_blob)
        link.download = fileName + '.' + exName
        link.click()
        window.URL.revokeObjectURL(link.href)
      }
    },
    async getData() {
      this.loading = true
      if (!this.isAgent) {
        await getAllMessage().then(res => {
          this.listQuery.levelType = res.data.levelType
          this.listQuery.cardType = res.data.cardType
          this.memberMainList[0].value_list[0] = res.data.personalPerformance.TOTAL_AMOUNT || 0
          this.memberMainList[0].value_list[1] = res.data.personalPerformance.TOTAL_FV || 0
          this.memberMainList[1].value_list[0] = res.data.newRecommendation.NEWR
          this.memberMainList[2].value_list[0] = res.data.newrecommendationOnTheWeb.NEWRWEB
          this.memberMainList[3].value_list[0] = res.data.retainPerformance ? res.data.retainPerformance.BIG_LAST_POINT : 0
          this.memberMainList[4].value_list[0] = res.data.pioneeringAward ? res.data.pioneeringAward.HISBONUS_MARKET : ''
          this.memberMainList[5].value_list[0] = res.data.canUseF$
          this.memberMainList[6].value_list[0] = res.data.canUserH0
          this.memberMainList[7].value_list[0] = res.data.canUseNv
          this.memberMainList[7].units_list[0] = ' '
          this.memberMainList2[0].isCheck = res.data.thisweek.C !== 0
          this.memberMainList2[0].value = res.data.thisweek.SHOWWEEK
          this.memberMainList2[1].isCheck = res.data.thisweek7.C !== 0
          this.memberMainList2[1].value = res.data.thisweek7.SHOWWEEK
          this.memberMainList2[2].isCheck = res.data.thisweek14.C !== 0
          this.memberMainList2[2].value = res.data.thisweek14.SHOWWEEK
          this.memberMainList2[3].isCheck = res.data.thisweek21.C !== 0
          this.memberMainList2[3].value = res.data.thisweek21.SHOWWEEK
          // 本周业绩截止日期 赋值 和 倒计时 开始
          this.timeThisWeek.LAST_DAY = this.changeDateFormat(res.data.timethisweek.LAST_DAY)
          this.Remaining_milliseconds = res.data.timethisweek.ENDDAY * 86400000 + res.data.timethisweek.ENDHOUR * 3600000 + res.data.timethisweek.ENDMINUTE * 60000 + res.data.timethisweek.ENDSECOND
          let CountDown = setInterval(()=>{
            this.Remaining_milliseconds -= 1000
            this.timeThisWeek.ENDDAY = this.twoDigits(parseInt((this.Remaining_milliseconds / 1000 / 60 / 60 / 24).toString(),10))
            this.timeThisWeek.ENDHOUR = this.twoDigits(parseInt((this.Remaining_milliseconds / 1000 / 60 / 60 % 24).toString(),10))
            this.timeThisWeek.ENDMINUTE = this.twoDigits(parseInt((this.Remaining_milliseconds / 1000 / 60 % 60).toString(),10))
            this.timeThisWeek.ENDSECOND = this.twoDigits(parseInt((this.Remaining_milliseconds / 1000 % 60).toString(),10))
            if (this.Remaining_milliseconds < 0) {
              clearInterval(CountDown)
            }
          }, 1000)
          // 本周业绩截止日期 赋值 和 倒计时 结束
          this.timeMonthWeek = res.data.timeMonthweek
          this.timeMonthWeek.END_DATE = this.changeDateFormat(res.data.timeMonthweek.END_DATE)
          res.data.upgradedays ? this.upgradeDays =  res.data.upgradedays : ''
          this.upgradeDays.UPDAYTIME = res.data.upgradedays ? this.changeDateFormat(res.data.upgradedays.UPDAYTIME) : ''
          this.preTime = res.data.pretime ? res.data.pretime.D : ''
          this.bonusNum = res.data.internetImg.length
          this.bonus1 = res.data.internetImg.length>0 ? res.data.internetImg[0] : {}
          this.bonus2 = res.data.internetImg.length>1 ? res.data.internetImg[1] : {}
          this.bonus3 = res.data.internetImg.length>2 ? res.data.internetImg[2] : {}
          this.bonus4 = res.data.internetImg.length>3 ? res.data.internetImg[3] : {}
          this.bonus5 = res.data.internetImg.length>4 ? res.data.internetImg[4] : {}
          if (res.data.sustainableDevelopment!==null){
            this.sustainableDevelopment = res.data.sustainableDevelopment
          }
          this.loading = false
        }).catch(err => {
          console.warn(err)
        })
        await memberCard().then(res => {
          this.DistributorCardSrc = 'data:image/png;base64,' + res.data
          this.DistributorCardSrcList[0] = 'data:image/png;base64,' + res.data
        }).catch(err => {
          console.warn(err)
        })
      }
      await fetchHomepage().then(res => {
        this.home.lastLoginTime = res.data
      }).catch(err => {
        console.warn(err)
      })
      await accountBalanceSum().then(res => {
        if(res.data.canUseFdLocal){
          this.home.F$ = res.data.canUseFdLocal
        }else{
          this.home.F$ = 0
        }
      }).catch(err => {
        console.warn(err)
      })
      this.loading = false
    },
    parseNumber(val) {
      return num2string(val)
    },
    toListPdSendInfos() {
      this.$router.push(`/order-manager/confirmation-receipt`)
    },
    // 点击更多跳转
    moreClick() {
      this.$router.replace({name: 'News'})
    },
    // 单个新闻跳转
    newsClick(id) {
      this.$router.push({name: 'NewsView', params: {'id': id}})
    },
    // 点击下载App
    downApp() {
      // downAppLocal().then(() => {
      //   this.appDownShow = true
      //   const aEle = document.createElement("a")
      //   aEle.href = 'http://13.245.128.42/html/app.apk'
      //   document.body.appendChild(aEle)
      //   aEle.click()
      //   document.body.removeChild(aEle)
      // }).catch(err => {
      //   console.error(err)
      // })
    },
    showMapFn() {
      this.showMap = !this.showMap
    },
    twoDigits(_num) {
      if (_num < 10) {
        _num = "0" + _num
      }
      return _num
    },
    changeDateFormat(_Date) {
      // _Date 示例格式  2021-01-09
      const _DateArr = _Date.split('-')
      if (this.language === 'zh_CN') {
        return _DateArr[0] + '年' + _DateArr[1] + '月' + _DateArr[2] + '日'
      } else {
        return _DateArr[2] + '/' + _DateArr[1] + '/' + _DateArr[0]
      }
    }
  }
}
</script>

<style lang="scss">

table.home_panel_body td {
  border: 1px solid #f09531;
  font-weight: bold;
}

h4.announceTitle {
  cursor: pointer;
}

h4.announceTitle:hover {
  color: #0a76a4;
}

div.el-card__body {
  padding-right: 20px !important;
  padding-bottom: 20px !important;
}

.eachDiv {
  height: 130px;
}

.cont_btm_top {
  width: 100%;
  height: 42px;
  margin: 13px auto 0;
  background-image: url('~@/assets/images/btnbg2.jpg');
  background-size: 110% 110%;
  background-repeat: no-repeat;
  background-position: 0 0;
  border-radius: 5px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.cont_btm_mid {
  width: 100%;
  height: 42px;
  margin: 12px auto 0;
  background-image: url('~@/assets/images/btnbg2.jpg');
  background-size: 110% 110%;
  background-repeat: no-repeat;
  background-position: 0 0;
  border-radius: 5px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  cursor: pointer;
}

.triangular {
  width: 0;
  height: 0;
  border-top: 10px solid #333;
  border-right: 10px solid transparent;
  transform: rotate(-45deg);
  position: relative;
  left: 620px;
  top: 15px;
  transition: all .3s;
}

.triangular2 {
  width: 0 !important;
  height: 0 !important;
  border-top: 10px solid #333 !important;
  border-right: 10px solid transparent !important;
  transform: rotate(-135deg) !important;
  position: relative !important;
  left: 620px !important;
  top: 15px !important;
  transition: all .3s !important;
}
</style>
